// extracted by mini-css-extract-plugin
export default {"header":"BuildingsData_header__2UX84","content":"BuildingsData_content__Nx-Tj","button":"BuildingsData_button__kVFpc","placeHolderShimmer":"BuildingsData_placeHolderShimmer__RFGZz"};